// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body,html{\n  padding: 0;\n  margin: 0;\n}", ""]);
// Exports
module.exports = exports;
